import { render, staticRenderFns } from "./ViewNotice.vue?vue&type=template&id=00e11a90&"
import script from "./ViewNotice.vue?vue&type=script&lang=js&"
export * from "./ViewNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports